<div class="page page-login">
  <ng-container *ngIf="credentialStep">
    <div class="login-text">Login to your account</div>
    <form
      #form="ngForm"
      *ngIf="formInit"
      [antiAutoComplete]="antiAutocomplete"
      novalidate
      (ngSubmit)="submitReCaptcha(form)"
    >
      <div class="grid">
        <div class="col-12">
          <div class="ui-inputgroup">
            <div
              class="ui-float-label login-float"
              [class.float-label]="!!user.email"
              style="flex-grow: 1"
            >
              <input
                size="40"
                id="email"
                name="email"
                type="email"
                autocomplete="off"
                [(ngModel)]="user.email"
                #email="ngModel"
                pattern='^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                required
              />
              <label for="email">Email Address</label>
              <button
                *ngIf="user.email"
                type="button"
                class="toggle-password-btn"
                (click)="clearEmail(email)"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
        <span *ngIf="email.invalid && email.touched" class="inline-error">
          Please input a valid email.
        </span>
      </div>
      <div class="grid">
        <div class="col-12">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!user.password"
            style="flex-grow: 1; position: relative"
          >
            <input
              size="40"
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="new-password"
              [(ngModel)]="user.password"
              #password="ngModel"
              required
            />
            <label for="password">Password</label>
            <button
              type="button"
              class="toggle-password-btn"
              (click)="showPassword = !showPassword"
            >
              {{ showPassword ? 'Hide' : 'Show' }}
              <img
                class="caps-lock-img"
                alt="caps-lock"
                *ngIf="!showPassword && isCapsLockOn"
                pTooltip="The Caps Lock key is on"
                src="assets/images/icons/svg/caps-lock-icon.svg"
              />
            </button>
          </div>
        </div>
        <span *ngIf="password.invalid && password.touched" class="inline-error">
          Password required.
        </span>

        <div class="flex flex-wrap" style="width: 100%">
          <div style="text-align: left; flex-grow: 99" class="forgot-password">
            <button type="button" class="forgot-password-btn" (click)="forgotPassword()">
              Forgot Password
            </button>
          </div>
          <div style="text-align: left; flex-grow: 1" class="remember-me">
            <p-checkbox
              class="style2023"
              id="rememberMe"
              name="rememberMe"
              [(ngModel)]="user.rememberMe"
              binary="true"
            ></p-checkbox>
            <label class="checkbox-label">Remember me</label>
          </div>
        </div>

        <!--                <a routerLink="/account/forgotpassword">Forgot Password</a>-->
      </div>
      <div class="grid">
        <div class="col-12">
          <re-captcha
            *ngIf="useCaptcha"
            id="recaptcha2"
            name="recaptcha"
            #recaptcha="ngModel"
            [(ngModel)]="token"
            required
            [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"
          ></re-captcha>

          <button
            style="margin-top: 10px"
            pButton
            type="submit"
            [disabled]="form.invalid"
            id="LogIn2"
            label="Login"
          ></button>

          <div style="margin-top: 20px">
            <span
              style="color: var(--grey-500); font-family: 'Roboto', 'Helvetica Neue', sans-serif"
            >
              New to Engineius?
              <a class="contact-us-link" href="http://www.engineius.co.uk">Contact Us</a> for more
              information
            </span>
          </div>
          <div class="error-msg" *ngIf="errorMsg">
            <i class="fa fa-exclamation-circle" style="margin-right: 5px"></i>
            <span [innerHTML]="errorMsg"></span>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="authenticatorStep">
    <div class="login-text" style="margin-bottom: 8px">Two-Factor Authentication</div>
    <div class="instruction-text">
      <span *ngIf="!user.useRecoveryCodeLogin"
        >Enter the 6-digit code shown in your authenticator app</span
      >
      <span *ngIf="user.useRecoveryCodeLogin">Enter one of your single-use recovery codes</span>
    </div>

    <form
      #form1="ngForm"
      *ngIf="isAuthenticatorSelected()"
      [antiAutoComplete]="antiAutocomplete"
      novalidate
      (ngSubmit)="submitReCaptcha(form1)"
    >
      <div class="ui-g-12">
        <div
          class="ui-float-label login-float"
          [class.float-label]="!!user.twoFactorCode"
          style="flex-grow: 1; position: relative"
        >
          <input
            required
            [id]="twoFaCodeInputElId"
            name="twoFactorCode"
            type="text"
            [(ngModel)]="user.twoFactorCode"
            #twoFactorCode="ngModel"
            [attr.inputmode]="user.useRecoveryCodeLogin ? 'text' : 'numeric'"
            [pattern]="user.useRecoveryCodeLogin ? '[A-Za-z0-9]*' : '[0-9]*'"
            autocomplete="one-time-code"
          />
          <label [for]="twoFaCodeInputElId">
            <span *ngIf="!user.useRecoveryCodeLogin">Authenticator code</span>
            <span *ngIf="user.useRecoveryCodeLogin">Recovery code</span>
          </label>
        </div>
        <span
          class="inline-error inline-error-reserved"
          [class.is-hidden]="!(twoFactorCode.invalid && twoFactorCode.touched)"
        >
          <span *ngIf="!user.useRecoveryCodeLogin">Authenticator code is required</span>
          <span *ngIf="user.useRecoveryCodeLogin">Recovery code is required.</span>
        </span>
      </div>

      <div class="ui-g-12 recovery-checkbox" *ngIf="!user.useRecoveryCodeLogin">
        <p-checkbox
          class="style2023"
          pTooltip="Skip the authenticator code on this browser for 30 days."
          id="rememberDevice"
          name="rememberDevice"
          [(ngModel)]="user.rememberDevice"
          binary="true"
        ></p-checkbox>
        <label class="checkbox-label">Don't ask again on this device for 30 days</label>
        <div class="recovery-info" *ngIf="user.rememberDevice">
          Only use this on a device that is private to you. You will be asked for a code again if
          you clear your browser cookies, change your password, or your two-factor authentication is
          reset.
        </div>
      </div>

      <div class="ui-g-12 recovery-checkbox" *ngIf="user.useRecoveryCodeLogin">
        <div class="recovery-info" style="padding-top: 0">
          Recovery codes were provided to you on initial sign-in. Each one can only be used once, so
          only use one if you have lost your authenticator device.
        </div>
      </div>

      <div class="ui-g-12">
        <re-captcha
          *ngIf="useCaptcha"
          id="recaptcha"
          name="recaptcha"
          #recaptcha="ngModel"
          [(ngModel)]="token"
          required
          [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"
        ></re-captcha>

        <button
          style="margin-top: 10px"
          pButton
          type="submit"
          [disabled]="form1.invalid"
          icon="fa ui-icon-person"
          id="LogIn"
          label="Log In"
        ></button>
        <div class="error-msg" *ngIf="errorMsg">
          <i class="fa fa-exclamation-circle" style="margin-right: 5px"></i>
          <span [innerHTML]="errorMsg"></span>
        </div>
        <div class="recovery-toggle">
          <a id="useRecoveryCode" (click)="toggleRecoveryCodeLogin()">
            {{
              user.useRecoveryCodeLogin
                ? 'Use your authenticator code'
                : 'Use a recovery code instead'
            }}
          </a>
        </div>
      </div>
    </form>
  </ng-container>

  <!-- auth setup step 1 -->
  <ng-container *ngIf="enablingAuthenticatorStep == 1">
    <div class="login-text">Setup Your Two-Factor Authentication</div>
    <div class="instruction-text">1. Download an authenticator app on your phone.</div>
    <div class="sub-text">
      Recommended apps are Microsoft Authenticator or Google Authenticator.
    </div>
    <div class="sub-text">Once you have downloaded one, click next to continue your 2FA setup.</div>
    <div style="width: 100%; margin-top: 14px">
      <img
        class="download-img"
        src="assets/images/icons/svg/download-image.svg"
        alt="download-image"
      />
    </div>
  </ng-container>
  <!-- -->

  <!-- auth setup step 2 -->
  <ng-container *ngIf="enablingAuthenticatorStep == 2">
    <div class="login-text">Setup Your Two-Factor Authentication</div>
    <div class="instruction-text">2. Scan QR code or input key</div>
    <div class="sub-text">
      <span>Scan the QR code or enter the key below within your authentication app.</span>
      <div><b>Note:</b> spacing and casing do not matter if you input the key</div>
    </div>
    <div class="qrcodeImage">
      <qrcode
        [qrdata]="enabling2FA.authenticatorUri"
        [ariaLabel]="'QR Code image with the following content...'"
        style="display: flex; flex: 1; justify-content: center"
        [colorDark]="'#000000ff'"
        [colorLight]="'#ffffffff'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [margin]="0"
        [scale]="1"
        [width]="120"
      ></qrcode>
    </div>
    <div>or</div>
    <div style="width: 100%">
      <strong>{{ enabling2FA.sharedKey }}</strong>
    </div>
  </ng-container>
  <!-- -->

  <!-- auth setup step 3 (verify code) -->
  <ng-container *ngIf="enablingAuthenticatorStep == 3">
    <div class="login-text">Setup Your Two-Factor Authentication</div>
    <div class="instruction-text">3. Input your verification code below</div>
    <div class="sub-text">
      <div>
        Once you have scanned the QR code or input the key, your two factor authentication app will
        provide you with a unique code.
      </div>
      <div>
        Look for the account ‘Engineius’ followed by your user email to identify the correct code to
        use, then enter this code in the confirmation box below.
      </div>
    </div>
    <div class="grid">
      <div class="md-inputfield"></div>
    </div>
    <div class="grid">
      <div class="col-12">
        <div class="ui-inputgroup">
          <div
            class="ui-float-label login-float"
            [class.float-label]="!!enabling2FA.code"
            style="flex-grow: 1"
          >
            <input
              id="codeValue"
              name="codeValue"
              [(ngModel)]="enabling2FA.code"
              maxlength="20"
              autocomplete="off"
              #codeValue="ngModel"
            />
            <label>Verification Code</label>
          </div>
        </div>
      </div>
      <span *ngIf="codeValue.invalid && codeValue.touched" class="inline-error">
        Please enter your verification code.
      </span>
    </div>
  </ng-container>
  <!-- -->

  <!-- auth setup step 4 (last step - goto portal) -->
  <ng-container *ngIf="enablingAuthenticatorStep == 4">
    <div class="login-text">Setup Your Two-Factor Authentication</div>
    <div class="instruction-text">4. Lastly, save your recovery codes</div>
    <div class="sub-text">
      <div>
        In the event that you lose/change your device or remove the authentication account, please
        save the recovery codes provided below to be able to login.
      </div>
      <div>Each recovery code can only be used once, after which it is no longer valid</div>
    </div>

    <div class="code-list">
      <div *ngFor="let code of enabling2FA.recoveryCode; let i = index" class="code-item">
        <strong>{{ code }}</strong>
      </div>
    </div>
  </ng-container>
  <!-- -->

  <ng-container *ngIf="enablingAuthenticatorStep > 0">
    <div *ngIf="enablingAuthenticatorStep == 4" class="copy-button-container">
      <button (click)="copyCodes()" class="copy-button">
        <i class="fa fa-clipboard" aria-hidden="true"></i
        ><span style="margin-left: 5px">Copy Codes</span>
      </button>
    </div>

    <div class="button-container">
      <!--Once the code is verified, 2FA is already enabled, so the user can't go back from the recovery codes step-->
      <button
        *ngIf="enablingAuthenticatorStep != 4"
        (click)="authBack()"
        pButton
        class="ui-button secondary"
        type="button"
        [disabled]="enablingAuthenticatorStep == 1"
        id="Back"
        label="Back"
      ></button>
      <button
        *ngIf="enablingAuthenticatorStep < Max2FASteps - 1"
        (click)="authNext()"
        pButton
        class="ui-button primary"
        type="button"
        id="Next"
        label="Next"
      ></button>
      <button
        *ngIf="enablingAuthenticatorStep == 3"
        pButton
        (click)="verifyCode()"
        label="Verify"
        class="ui-button primary"
      ></button>
      <button
        *ngIf="enablingAuthenticatorStep == 4"
        pButton
        (click)="goToPortal()"
        label="Login to Portal"
        class="ui-button primary"
      ></button>
    </div>

    <!--    <div class="flex" style="margin-top: 14px">-->
    <!--      <div class="flex-grow-1">-->
    <!--        <button-->
    <!--          (click)="authBack()"-->
    <!--          style="width: 90%"-->
    <!--          pButton-->
    <!--          type="button"-->
    <!--          [disabled]="enablingAuthenticatorStep == 1"-->
    <!--          id="Back"-->
    <!--          label="Back"-->
    <!--        ></button>-->
    <!--      </div>-->
    <!--      <div class="flex-grow-1">-->
    <!--        <button-->
    <!--          *ngIf="enablingAuthenticatorStep < Max2FASteps - 1"-->
    <!--          (click)="authNext()"-->
    <!--          style="width: 90%"-->
    <!--          pButton-->
    <!--          type="button"-->
    <!--          id="Next"-->
    <!--          label="Next"-->
    <!--        ></button>-->
    <!--        <button-->
    <!--          *ngIf="enablingAuthenticatorStep == 3"-->
    <!--          style="width: 90%"-->
    <!--          pButton-->
    <!--          (click)="verifyCode()"-->
    <!--          label="Verify"-->
    <!--          class="ui-button primary"-->
    <!--        ></button>-->
    <!--          <button-->
    <!--              *ngIf="enablingAuthenticatorStep == 4"-->
    <!--              style="width: 90%"-->
    <!--              pButton-->
    <!--              (click)="goToPortal()"-->
    <!--              label="Login to Portal"-->
    <!--              class="ui-button primary"-->
    <!--          ></button>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="error-msg" *ngIf="errorMsg">
      <i class="fa fa-exclamation-circle" style="margin-right: 5px"></i>
      <span [innerHTML]="errorMsg"></span>
    </div>
  </ng-container>

  <p-toast key="deactivated" position="top-center">
    <ng-template let-message pTemplate="message">
      <h4 innerHtml="{{ message.summary }}"></h4>
      <p innerHtml="{{ message.detail }}"></p>
    </ng-template>
  </p-toast>
</div>
